var map = {
	"./add_icon.svg": 9290,
	"./card_cvv.svg": 1113,
	"./card_expiry.svg": 603,
	"./close_icon.svg": 5785,
	"./copy_icon.svg": 2158,
	"./credit_card.svg": 3503,
	"./debit_credit_card.svg": 5444,
	"./delete_icon.svg": 8260,
	"./down_arrow.svg": 5703,
	"./download.svg": 7177,
	"./edit_icon.svg": 6895,
	"./edit_icon_black.svg": 9427,
	"./edit_small_white_icon.svg": 4701,
	"./email_invite_storytelling_icon.svg": 1270,
	"./end_meeting_hover_icon.svg": 7095,
	"./end_meeting_static_icon.svg": 133,
	"./eye-hide-svgrepo-com.svg": 8388,
	"./eye-show-svgrepo-com.svg": 347,
	"./feedback_white_icon.svg": 6626,
	"./menu_list_dropdown.svg": 6529,
	"./merge_whiteboard_hover_icon.svg": 8132,
	"./merge_whiteboard_pause_hover_icon.svg": 4213,
	"./merge_whiteboard_paused_icon.svg": 864,
	"./merge_whiteboard_sharing_icon.svg": 4082,
	"./merge_whiteboard_static_icon.svg": 2208,
	"./mute_off_icon.svg": 3168,
	"./mute_on_icon.svg": 7590,
	"./overflow_purple.svg": 5916,
	"./overflow_small_white_icon.svg": 2463,
	"./overflow_white_transparent.svg": 3642,
	"./participants_hover_icon.svg": 5948,
	"./participants_static_icon.svg": 6840,
	"./paused_small_white_icon.svg": 2811,
	"./profile_icon.svg": 8232,
	"./search_purple_icon.svg": 5802,
	"./settings_white_icon.svg": 5464,
	"./share.svg": 3650,
	"./tick.svg": 2890
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;